module.exports = __webpack_public_path__ + "static2023-4-17/img/week_5.70afb070.png";